import {MatchEvent} from '../resources/MatchEvent';
import {DomainEvent} from './DomainEvent';

export class MatchEventWhistleRegularStartSecondHalftime extends DomainEvent<MatchEvent> {}
